// Community Safety Hub — self-contained localisation (en/es/de/fr/nl/ar).
// Falls back to English for any missing key so no surface ever shows a raw key.
import { useTranslation } from 'react-i18next';

const D = {
  en: {
    tabAlerts: 'Official Updates',     unreadNotifications: 'Unread notifications',
tabIncidents: 'Incidents', tabCommunity: 'Community', tabHelp: 'Help',
    activeIncidents: 'Active incidents', noIncidents: 'No incidents at the moment — that is good news.',
    createIncident: 'Create Incident Room', incidentTitle: 'Incident title', incidentDesc: 'Description',
    areasAffected: 'Areas affected', statusLabel: 'Status', severityLabel: 'Severity',
    lastOfficialUpdate: 'Last official update', officialContacts: 'Official contacts',
    viewIncident: 'View Incident', officialUpdates: 'Official Updates', requestHelp: 'Request Help', offerHelp: 'Offer Help',
    whatsHappening: 'What\u2019s happening',
    summaryFromReport: 'Summary from the most recent community report on this incident.',
    summaryFromUpdate: 'Summary from the most recent official update on this incident.',
    noCurrentInfo: 'No current information posted yet. Check the Official Updates and Community Reports below, or call 112 in an emergency.',
    detailsMinHint: 'minimum 10 characters',
    detailsPlaceholder: 'Please describe what is happening (minimum 10 characters)',
    detailsMoreNeeded: '{count} more characters required',
    detailsOneMore: '1 more character required',
    detailsComplete: 'Description complete',
    editAlert: 'Edit alert',
    deleteAlert: 'Delete alert',
    deleteAlertTitle: 'Delete this alert?',
    deleteAlertBody: 'This will remove the alert from the community feed.',
    editSaved: 'Alert updated',
    ownerMenu: 'Owner actions',
    communityReports: 'Community Reports', newReport: 'New Report', postUpdate: 'Post Official Update',
    followIncident: 'Follow incident', followingIncident: 'Following', followers: 'followers',
    confirmSeen: 'Seen this too', confirmed: 'Confirmed', reply: 'Reply', replies: 'Replies',
    reportIncorrect: 'Report incorrect', share: 'Share', witnessed: 'Witnessed first-hand',
    town: 'Town', area: 'Area / street (optional)', category: 'Category', timeSeen: 'Time seen',
    helpType: 'Type of help', describe: 'Describe what you saw or need', submit: 'Submit', cancel: 'Cancel',
    expiredUpdates: 'Expired updates', showExpired: 'Show expired updates', hideExpired: 'Hide expired updates',
    expired: 'Expired', resolved: 'Resolved', markResolved: 'Mark resolved',
    needHelp: 'I Need Help', canHelp: 'I Can Help', noHelpPosts: 'No help posts right now.',
    signInToPost: 'Sign in to post', locked: 'This item is locked for new updates.',
    lockRoom: 'Lock room', unlockRoom: 'Unlock room', removePost: 'Remove post',
    deletePost: 'Delete post', deleteDone: 'Post deleted',
    noticeRemovedTitle: 'Post removed',
    noticeRemoved: 'This post has been removed by a moderator and is no longer available.',
    noticeResolved: 'This post has been resolved and is no longer active.',
    noticeExpired: 'This post has expired and is no longer active.',
    noticeDeleted: 'This post is no longer available.',
    // Unified Hub (Jul 2026 redesign · refined Feb 2026 · renamed Community Hub Feb 2026 v3)
    hubName: 'Community Hub',
    hubTagline: 'Local information, help, lost & found and marketplace — one place for your community.',
    following: 'Following', manageTowns: 'Manage Towns', shareInfo: 'Share Local Information',
    latestInfo: 'Latest Local Information',
    noInfoTitle: 'Nothing important to report right now',
    noInfoBody: 'There are currently no important local updates for your followed towns.',
    noInfoCta: 'If you have something your community should know, tap Share Local Information.',
    updates: 'Updates', update: 'Update', viewUpdates: 'View updates', open: 'Open',
    updated: 'Updated', posted: 'Posted', officialAuthority: 'Official Authority',
    moreTowns: 'more',
    affectedTown: 'Affected Town', categoryLabel: 'Category', titleLabel: 'Title', detailsLabel: 'Details',
    confirmTruth: 'I confirm this information is truthful.',
    confirmNoPI: 'I understand I must not include names, accusations or personal information.',
    attachPrompt: 'Is this an update to one of these existing items?',
    attachNew: 'No — this is a new item', sharedOk: 'Thank you — your information has been shared.',
    expiryLabel: 'How long should this stay visible?', expiryDefault: 'Default for this category', days: 'days',
    catFireSmoke: 'Fire / Smoke', catHazard: 'Safety Hazard', catRoad: 'Road Closure',
    catNeedHelp: 'Need Help', catOfferHelp: 'Offer Help', catPet: 'Lost / Found Pet', catInfo: 'Community Information',
    followNoTowns: 'Follow your town to see and receive local information.',
    emergencyRow: 'Emergency Numbers', emergencyRowSub: 'Police, Fire, Ambulance and essential contacts',
    marketplaceRow: 'Marketplace', marketplaceRowSub: 'Buy, sell, wanted or free items in your community',
    lostFoundRow: 'Lost & Found', lostFoundRowSub: 'Pets, keys, wallets, ID, phones — help reunite items with owners',
    createPost: 'Create Community Post',
    postPickerTitle: 'What would you like to post?',
    postPickerSubtitle: 'Choose the type of post — the form will adapt automatically.',
    postOfficialTitle: 'Official Alert',
    postOfficialDesc: 'Publish a verified authority notice.',
    postAlertTitle: 'Community Alert',
    postAlertDesc: 'Fire, road closure, hazard or something the town should know.',
    postLostTitle: 'Lost Something',
    postLostDesc: 'Pets, keys, wallet, ID, phone.',
    postFoundTitle: 'Found Something',
    postFoundDesc: 'Help return an item to its owner.',
    postHelpNeededTitle: 'Need Help',
    postHelpNeededDesc: 'Ask your community for practical help.',
    postHelpOfferedTitle: 'Offer Help',
    postHelpOfferedDesc: 'Offer time, transport or practical assistance to neighbours.',
    view: 'View', allTowns: 'All towns', signInToShare: 'Sign in to share information',
    deleteConfirmMsg: 'Are you sure you want to permanently delete this post? Replies and related notifications will be removed for everyone. This action cannot be undone.',
    falseInfo: 'False information', spam: 'Spam', abuse: 'Abuse', otherReason: 'Other',
    whyIncorrect: 'Why is this incorrect?', sent: 'Sent — thank you.',
    emergencyBannerTitle: 'Active incident in your area',
    postedBy: 'Posted by', official: 'OFFICIAL', communityLbl: 'Community',
    editIncident: 'Edit / change status', selectTowns: 'Select affected towns',
    contactsHint: 'Contact numbers (label + number)', addContact: 'Add contact',
    updateType: 'Update type', reportPosted: 'Report published — it will auto-expire unless neighbours confirm it.',
    loadMoreReplies: 'View replies', writeReply: 'Write a reply…', noReports: 'No community reports yet.',
    call112: 'Emergency? Call 112', resolvedBanner: 'This incident has been resolved.',
    allTowns: 'All towns', filterTown: 'Filter by town',
    status_active: 'Active', status_monitoring: 'Monitoring', status_resolved: 'Resolved', status_archived: 'Archived',
    sev_normal: 'Normal', sev_high: 'High', sev_critical: 'Critical',
    it_wildfire: 'Wildfire', it_flood: 'Flood', it_severe_weather: 'Severe weather', it_road_closure: 'Road closure',
    it_power_outage: 'Power outage', it_missing_person: 'Missing person', it_other: 'Other emergency',
    ut_evacuation_order: 'Evacuation order', ut_road_closure: 'Road closure', ut_shelter: 'Shelter location',
    ut_emergency_instructions: 'Emergency instructions', ut_safe_route: 'Safe route', ut_official_update: 'Official update',
    rc_smoke_seen: 'Smoke seen', rc_fire_location: 'Fire location', rc_road_blocked: 'Road blocked',
    rc_power_outage: 'Electricity outage', rc_flooding: 'Flooding', rc_fallen_tree: 'Fallen tree',
    rc_help_needed: 'Help needed', rc_help_offered: 'Help offered', rc_animal_assistance: 'Animal assistance',
    rc_general_update: 'Local update',
    rc_fire_smoke: 'Fire / Smoke', rc_safety_hazard: 'Safety hazard', rc_road_closure: 'Road closure',
    rc_lost_pet: 'Lost / Found pet', rc_community_info: 'Community information', it_community: 'Community',
    ht_transport: 'Transport', ht_accommodation: 'Temporary accommodation', ht_animal_transport: 'Animal transport',
    ht_water: 'Water', ht_food: 'Food', ht_phone_charging: 'Charging phones', ht_welfare_check: 'Welfare check', ht_other: 'Other assistance',
    photosLabel: 'Photos (optional)',
    photosHelp: 'Add up to 3 photos from your camera or gallery. Large images are resized automatically before upload.',
    addPhoto: 'Add photo',
    removePhoto: 'Remove photo',
    replace: 'Replace',
    photoInvalidType: 'That file isn\u2019t an image we can accept.',
    photoUploadFailed: 'Photo upload failed — please try again.',
    photoHeicFailed: 'Could not convert that iPhone photo. Please pick another.',
    scheduleTitle: 'Alert / Event Dates (optional)',
    scheduleHelp: 'Set when this alert appears and when the event itself starts and ends. All fields are optional.',
    showImmediately: 'Show immediately',
    showAlertFrom: 'Show alert from',
    eventStarts: 'Event starts',
    eventEnds: 'Event ends',
    autoExpireOnEnd: 'Automatically expire alert after event ends',
    scheduleInvalid: 'Event end must be after event start, and \u201cShow alert from\u201d cannot be after the event start.',
    upcoming: 'Upcoming',
    starts: 'Starts',
    expectedToEnd: 'Expected to end',
    reminderLabel: 'Reminder notification',
    reminderHelp: 'Send an extra reminder to town followers a set time before the event starts. Only sent once, and only if the reminder time hasn\u2019t already passed.',
    reminderNone: 'No reminder',
    reminder_1: '1 hour before',
    reminder_3: '3 hours before',
    reminder_6: '6 hours before',
    reminder_12: '12 hours before',
    reminder_24: '24 hours before',
  },
  es: {
    tabAlerts: 'Avisos oficiales',     unreadNotifications: 'Notificaciones sin leer',
tabIncidents: 'Incidentes', tabCommunity: 'Comunidad', tabHelp: 'Ayuda',
    activeIncidents: 'Incidentes activos', noIncidents: 'No hay incidentes en este momento — buena señal.',
    createIncident: 'Crear sala de incidente', incidentTitle: 'Título del incidente', incidentDesc: 'Descripción',
    areasAffected: 'Zonas afectadas', statusLabel: 'Estado', severityLabel: 'Gravedad',
    lastOfficialUpdate: 'Última actualización oficial', officialContacts: 'Contactos oficiales',
    viewIncident: 'Ver incidente', officialUpdates: 'Actualizaciones oficiales', requestHelp: 'Pedir ayuda', offerHelp: 'Ofrecer ayuda',
    whatsHappening: 'Qué está pasando',
    summaryFromReport: 'Resumen extraído del informe comunitario más reciente sobre este incidente.',
    summaryFromUpdate: 'Resumen extraído de la actualización oficial más reciente sobre este incidente.',
    noCurrentInfo: 'Todavía no hay información publicada. Consulta las actualizaciones oficiales y los informes comunitarios más abajo, o llama al 112 en caso de emergencia.',
    detailsMinHint: 'mínimo 10 caracteres',
    detailsPlaceholder: 'Por favor describe lo que está ocurriendo (mínimo 10 caracteres)',
    detailsMoreNeeded: 'Faltan {count} caracteres',
    detailsOneMore: 'Falta 1 carácter',
    detailsComplete: 'Descripción completa',
    editAlert: 'Editar alerta',
    deleteAlert: 'Eliminar alerta',
    deleteAlertTitle: '¿Eliminar esta alerta?',
    deleteAlertBody: 'La alerta se eliminará del feed de la comunidad.',
    editSaved: 'Alerta actualizada',
    ownerMenu: 'Acciones del autor',
    communityReports: 'Informes de la comunidad', newReport: 'Nuevo informe', postUpdate: 'Publicar actualización oficial',
    followIncident: 'Seguir incidente', followingIncident: 'Siguiendo', followers: 'seguidores',
    confirmSeen: 'Yo también lo vi', confirmed: 'Confirmado', reply: 'Responder', replies: 'Respuestas',
    reportIncorrect: 'Marcar como incorrecto', share: 'Compartir', witnessed: 'Visto en persona',
    town: 'Localidad', area: 'Zona / calle (opcional)', category: 'Categoría', timeSeen: 'Hora vista',
    helpType: 'Tipo de ayuda', describe: 'Describe lo que viste o necesitas', submit: 'Enviar', cancel: 'Cancelar',
    expiredUpdates: 'Actualizaciones caducadas', showExpired: 'Mostrar caducadas', hideExpired: 'Ocultar caducadas',
    expired: 'Caducado', resolved: 'Resuelto', markResolved: 'Marcar como resuelto',
    needHelp: 'Necesito ayuda', canHelp: 'Puedo ayudar', noHelpPosts: 'No hay peticiones de ayuda ahora mismo.',
    signInToPost: 'Inicia sesión para publicar', locked: 'Esta sala de incidente está bloqueada.',
    lockRoom: 'Bloquear sala', unlockRoom: 'Desbloquear sala', removePost: 'Eliminar publicación',
    deletePost: 'Borrar publicación', deleteDone: 'Publicación borrada',
    noticeRemovedTitle: 'Publicación eliminada',
    noticeRemoved: 'Esta publicación ha sido eliminada por un moderador y ya no está disponible.',
    noticeResolved: 'Esta publicación se ha resuelto y ya no está activa.',
    noticeExpired: 'Esta publicación ha caducado y ya no está activa.',
    noticeDeleted: 'Esta publicación ya no está disponible.',
    // Unified Hub (Jul 2026 · refinado Feb 2026 · renombrado Centro Comunitario Feb 2026 v3)
    hubName: 'Centro Comunitario',
    hubTagline: 'Información local, ayuda, objetos perdidos y mercado — todo en un solo lugar para tu comunidad.',
    following: 'Siguiendo', manageTowns: 'Gestionar localidades', shareInfo: 'Compartir información local',
    latestInfo: 'Información local reciente',
    noInfoTitle: 'Nada importante que informar ahora mismo',
    noInfoBody: 'De momento no hay novedades importantes para las localidades que sigues.',
    noInfoCta: 'Si hay algo que tu comunidad debería saber, pulsa Compartir información local.',
    updates: 'Actualizaciones', update: 'Actualización', viewUpdates: 'Ver actualizaciones', open: 'Abrir',
    updated: 'Actualizado', posted: 'Publicado', officialAuthority: 'Autoridad Oficial',
    moreTowns: 'más',
    affectedTown: 'Localidad afectada', categoryLabel: 'Categoría', titleLabel: 'Título', detailsLabel: 'Detalles',
    confirmTruth: 'Confirmo que esta información es veraz.',
    confirmNoPI: 'Entiendo que no debo incluir nombres, acusaciones ni información personal.',
    attachPrompt: '¿Es una actualización de alguno de estos elementos?',
    attachNew: 'No — es un elemento nuevo', sharedOk: 'Gracias — tu información se ha compartido.',
    expiryLabel: '¿Cuánto tiempo debe permanecer visible?', expiryDefault: 'Por defecto para esta categoría', days: 'días',
    catFireSmoke: 'Fuego / Humo', catHazard: 'Peligro de seguridad', catRoad: 'Corte de carretera',
    catNeedHelp: 'Necesito ayuda', catOfferHelp: 'Ofrezco ayuda', catPet: 'Mascota perdida / encontrada', catInfo: 'Información comunitaria',
    followNoTowns: 'Sigue tu localidad para ver y recibir información local.',
    emergencyRow: 'Teléfonos de emergencia', emergencyRowSub: 'Policía, Bomberos, Ambulancia y contactos esenciales',
    marketplaceRow: 'Mercado', marketplaceRowSub: 'Compra, venta, se busca o artículos gratis en tu comunidad',
    lostFoundRow: 'Objetos perdidos y encontrados', lostFoundRowSub: 'Mascotas, llaves, carteras, DNI, móviles — ayuda a devolverlos a su dueño',
    createPost: 'Crear publicación comunitaria',
    postPickerTitle: '¿Qué quieres publicar?',
    postPickerSubtitle: 'Elige el tipo de publicación — el formulario se adapta automáticamente.',
    postOfficialTitle: 'Alerta oficial',
    postOfficialDesc: 'Publica un aviso verificado como autoridad.',
    postAlertTitle: 'Alerta comunitaria',
    postAlertDesc: 'Incendio, corte de carretera, peligro o algo que la localidad debe saber.',
    postLostTitle: 'He perdido algo',
    postLostDesc: 'Mascotas, llaves, cartera, DNI, teléfono.',
    postFoundTitle: 'He encontrado algo',
    postFoundDesc: 'Ayuda a devolver un objeto a su dueño.',
    postHelpNeededTitle: 'Necesito ayuda',
    postHelpNeededDesc: 'Pide ayuda práctica a tu comunidad.',
    postHelpOfferedTitle: 'Ofrezco ayuda',
    postHelpOfferedDesc: 'Ofrece tiempo, transporte o ayuda práctica a tus vecinos.',
    view: 'Ver', allTowns: 'Todas las localidades', signInToShare: 'Inicia sesión para compartir información',
    deleteConfirmMsg: '¿Seguro que quieres borrar esta publicación de forma permanente? Las respuestas y notificaciones relacionadas se eliminarán para todos. Esta acción no se puede deshacer.',
    falseInfo: 'Información falsa', spam: 'Spam', abuse: 'Abuso', otherReason: 'Otro',
    whyIncorrect: '¿Por qué es incorrecto?', sent: 'Enviado — gracias.',
    emergencyBannerTitle: 'Incidente activo en tu zona',
    postedBy: 'Publicado por', official: 'OFICIAL', communityLbl: 'Comunidad',
    editIncident: 'Editar / cambiar estado', selectTowns: 'Selecciona las localidades afectadas',
    contactsHint: 'Teléfonos de contacto (etiqueta + número)', addContact: 'Añadir contacto',
    updateType: 'Tipo de actualización', reportPosted: 'Informe publicado — caducará automáticamente si nadie lo confirma.',
    loadMoreReplies: 'Ver respuestas', writeReply: 'Escribe una respuesta…', noReports: 'Aún no hay informes de la comunidad.',
    call112: '¿Emergencia? Llama al 112', resolvedBanner: 'Este incidente ha sido resuelto.',
    allTowns: 'Todas las localidades', filterTown: 'Filtrar por localidad',
    status_active: 'Activo', status_monitoring: 'En seguimiento', status_resolved: 'Resuelto', status_archived: 'Archivado',
    sev_normal: 'Normal', sev_high: 'Alta', sev_critical: 'Crítica',
    it_wildfire: 'Incendio forestal', it_flood: 'Inundación', it_severe_weather: 'Tiempo severo', it_road_closure: 'Corte de carretera',
    it_power_outage: 'Apagón', it_missing_person: 'Persona desaparecida', it_other: 'Otra emergencia',
    ut_evacuation_order: 'Orden de evacuación', ut_road_closure: 'Corte de carretera', ut_shelter: 'Ubicación de refugio',
    ut_emergency_instructions: 'Instrucciones de emergencia', ut_safe_route: 'Ruta segura', ut_official_update: 'Actualización oficial',
    rc_smoke_seen: 'Humo visto', rc_fire_location: 'Ubicación del fuego', rc_road_blocked: 'Carretera bloqueada',
    rc_power_outage: 'Corte de luz', rc_flooding: 'Inundación', rc_fallen_tree: 'Árbol caído',
    rc_help_needed: 'Necesita ayuda', rc_help_offered: 'Ofrece ayuda', rc_animal_assistance: 'Ayuda con animales',
    rc_general_update: 'Aviso local',
    rc_fire_smoke: 'Fuego / Humo', rc_safety_hazard: 'Peligro de seguridad', rc_road_closure: 'Corte de carretera',
    rc_lost_pet: 'Mascota perdida / encontrada', rc_community_info: 'Información comunitaria', it_community: 'Comunidad',
    ht_transport: 'Transporte', ht_accommodation: 'Alojamiento temporal', ht_animal_transport: 'Transporte de animales',
    ht_water: 'Agua', ht_food: 'Comida', ht_phone_charging: 'Cargar móviles', ht_welfare_check: 'Visita de bienestar', ht_other: 'Otra ayuda',
    photosLabel: 'Fotos (opcional)',
    photosHelp: 'Añade hasta 3 fotos desde la cámara o la galería. Las imágenes grandes se comprimen automáticamente.',
    addPhoto: 'Añadir foto',
    removePhoto: 'Eliminar foto',
    replace: 'Reemplazar',
    photoInvalidType: 'Ese archivo no es una imagen válida.',
    photoUploadFailed: 'Error al subir la foto — inténtalo de nuevo.',
    photoHeicFailed: 'No se pudo convertir la foto del iPhone. Elige otra.',
    scheduleTitle: 'Fechas de alerta / evento (opcional)',
    scheduleHelp: 'Indica cuándo aparecerá esta alerta y cuándo empieza y termina el evento. Todos los campos son opcionales.',
    showImmediately: 'Mostrar inmediatamente',
    showAlertFrom: 'Mostrar alerta desde',
    eventStarts: 'El evento empieza',
    eventEnds: 'El evento termina',
    autoExpireOnEnd: 'Caducar automáticamente cuando termine el evento',
    scheduleInvalid: 'La fecha de fin debe ser posterior al inicio y \u201cMostrar alerta desde\u201d no puede ser posterior al inicio del evento.',
    upcoming: 'Próximo',
    starts: 'Empieza',
    expectedToEnd: 'Fin previsto',
    reminderLabel: 'Recordatorio',
    reminderHelp: 'Envía un aviso extra a los seguidores del pueblo antes de que empiece el evento. Se envía solo una vez y solo si la hora del recordatorio aún no ha pasado.',
    reminderNone: 'Sin recordatorio',
    reminder_1: '1 hora antes',
    reminder_3: '3 horas antes',
    reminder_6: '6 horas antes',
    reminder_12: '12 horas antes',
    reminder_24: '24 horas antes',
  },
  de: {
    tabAlerts: 'Offizielle Updates',     unreadNotifications: 'Ungelesene Benachrichtigungen',
tabIncidents: 'Vorfälle', tabCommunity: 'Gemeinschaft', tabHelp: 'Hilfe',
    activeIncidents: 'Aktive Vorfälle', noIncidents: 'Derzeit keine Vorfälle — ein gutes Zeichen.',
    createIncident: 'Vorfall-Raum erstellen', viewIncident: 'Vorfall ansehen', officialUpdates: 'Offizielle Updates',
    requestHelp: 'Hilfe anfordern', offerHelp: 'Hilfe anbieten', communityReports: 'Gemeinschaftsberichte',
    newReport: 'Neuer Bericht', confirmSeen: 'Auch gesehen', reply: 'Antworten', replies: 'Antworten',
    reportIncorrect: 'Als falsch melden', share: 'Teilen', witnessed: 'Selbst gesehen',
    town: 'Ort', category: 'Kategorie', submit: 'Senden', cancel: 'Abbrechen',
    expiredUpdates: 'Abgelaufene Updates', showExpired: 'Abgelaufene anzeigen', hideExpired: 'Abgelaufene ausblenden',
    expired: 'Abgelaufen', resolved: 'Gelöst', markResolved: 'Als gelöst markieren',
    needHelp: 'Ich brauche Hilfe', canHelp: 'Ich kann helfen', signInToPost: 'Zum Posten anmelden',
    emergencyBannerTitle: 'Aktiver Vorfall in Ihrer Nähe', official: 'OFFIZIELL', communityLbl: 'Gemeinschaft',
    call112: 'Notfall? 112 anrufen', resolvedBanner: 'Dieser Vorfall wurde gelöst.',
    followIncident: 'Vorfall folgen', followingIncident: 'Folgend',
    status_active: 'Aktiv', status_monitoring: 'Beobachtung', status_resolved: 'Gelöst', status_archived: 'Archiviert',
    sev_normal: 'Normal', sev_high: 'Hoch', sev_critical: 'Kritisch',
    it_wildfire: 'Waldbrand', it_flood: 'Überschwemmung', it_severe_weather: 'Unwetter', it_road_closure: 'Straßensperrung',
    it_power_outage: 'Stromausfall', it_missing_person: 'Vermisste Person', it_other: 'Anderer Notfall',
    ut_evacuation_order: 'Evakuierungsanordnung', ut_road_closure: 'Straßensperrung', ut_shelter: 'Notunterkunft',
    ut_emergency_instructions: 'Notfallanweisungen', ut_safe_route: 'Sichere Route', ut_official_update: 'Offizielles Update',
    rc_smoke_seen: 'Rauch gesehen', rc_fire_location: 'Feuerstelle', rc_road_blocked: 'Straße blockiert',
    rc_power_outage: 'Stromausfall', rc_flooding: 'Überschwemmung', rc_fallen_tree: 'Umgestürzter Baum',
    rc_help_needed: 'Hilfe benötigt', rc_help_offered: 'Hilfe angeboten', rc_animal_assistance: 'Tierhilfe',
    rc_general_update: 'Lokales Update',
    ht_transport: 'Transport', ht_accommodation: 'Unterkunft', ht_animal_transport: 'Tiertransport',
    ht_water: 'Wasser', ht_food: 'Essen', ht_phone_charging: 'Handys laden', ht_welfare_check: 'Wohlfahrtskontrolle', ht_other: 'Sonstige Hilfe',
  },
  fr: {
    tabAlerts: 'Mises à jour officielles',     unreadNotifications: 'Notifications non lues',
tabIncidents: 'Incidents', tabCommunity: 'Communauté', tabHelp: 'Aide',
    activeIncidents: 'Incidents actifs', noIncidents: 'Aucun incident pour le moment — bonne nouvelle.',
    createIncident: 'Créer une salle d\u2019incident', viewIncident: 'Voir l\u2019incident', officialUpdates: 'Mises à jour officielles',
    requestHelp: 'Demander de l\u2019aide', offerHelp: 'Offrir de l\u2019aide', communityReports: 'Signalements communautaires',
    newReport: 'Nouveau signalement', confirmSeen: 'Vu aussi', reply: 'Répondre', replies: 'Réponses',
    reportIncorrect: 'Signaler comme incorrect', share: 'Partager', witnessed: 'Vu en personne',
    town: 'Commune', category: 'Catégorie', submit: 'Envoyer', cancel: 'Annuler',
    expiredUpdates: 'Mises à jour expirées', showExpired: 'Afficher expirées', hideExpired: 'Masquer expirées',
    expired: 'Expiré', resolved: 'Résolu', markResolved: 'Marquer comme résolu',
    needHelp: 'J\u2019ai besoin d\u2019aide', canHelp: 'Je peux aider', signInToPost: 'Connectez-vous pour publier',
    emergencyBannerTitle: 'Incident actif dans votre zone', official: 'OFFICIEL', communityLbl: 'Communauté',
    call112: 'Urgence ? Appelez le 112', resolvedBanner: 'Cet incident a été résolu.',
    followIncident: 'Suivre l\u2019incident', followingIncident: 'Suivi',
    status_active: 'Actif', status_monitoring: 'Surveillance', status_resolved: 'Résolu', status_archived: 'Archivé',
    sev_normal: 'Normal', sev_high: 'Élevée', sev_critical: 'Critique',
    it_wildfire: 'Feu de forêt', it_flood: 'Inondation', it_severe_weather: 'Météo extrême', it_road_closure: 'Route fermée',
    it_power_outage: 'Panne de courant', it_missing_person: 'Personne disparue', it_other: 'Autre urgence',
    ut_evacuation_order: 'Ordre d\u2019évacuation', ut_road_closure: 'Route fermée', ut_shelter: 'Abri',
    ut_emergency_instructions: 'Consignes d\u2019urgence', ut_safe_route: 'Itinéraire sûr', ut_official_update: 'Mise à jour officielle',
    rc_smoke_seen: 'Fumée aperçue', rc_fire_location: 'Localisation du feu', rc_road_blocked: 'Route bloquée',
    rc_power_outage: 'Coupure de courant', rc_flooding: 'Inondation', rc_fallen_tree: 'Arbre tombé',
    rc_help_needed: 'Aide demandée', rc_help_offered: 'Aide offerte', rc_animal_assistance: 'Aide animaux',
    rc_general_update: 'Info locale',
    ht_transport: 'Transport', ht_accommodation: 'Hébergement temporaire', ht_animal_transport: 'Transport d\u2019animaux',
    ht_water: 'Eau', ht_food: 'Nourriture', ht_phone_charging: 'Recharge de téléphones', ht_welfare_check: 'Visite de contrôle', ht_other: 'Autre aide',
  },
  nl: {
    tabAlerts: 'Officiële updates',     unreadNotifications: 'Ongelezen meldingen',
tabIncidents: 'Incidenten', tabCommunity: 'Gemeenschap', tabHelp: 'Hulp',
    activeIncidents: 'Actieve incidenten', noIncidents: 'Momenteel geen incidenten — goed nieuws.',
    createIncident: 'Incidentruimte aanmaken', viewIncident: 'Bekijk incident', officialUpdates: 'Officiële updates',
    requestHelp: 'Hulp vragen', offerHelp: 'Hulp aanbieden', communityReports: 'Gemeenschapsmeldingen',
    newReport: 'Nieuwe melding', confirmSeen: 'Ook gezien', reply: 'Reageren', replies: 'Reacties',
    reportIncorrect: 'Als onjuist melden', share: 'Delen', witnessed: 'Zelf gezien',
    town: 'Plaats', category: 'Categorie', submit: 'Versturen', cancel: 'Annuleren',
    expiredUpdates: 'Verlopen updates', showExpired: 'Toon verlopen', hideExpired: 'Verberg verlopen',
    expired: 'Verlopen', resolved: 'Opgelost', markResolved: 'Markeer als opgelost',
    needHelp: 'Ik heb hulp nodig', canHelp: 'Ik kan helpen', signInToPost: 'Log in om te plaatsen',
    emergencyBannerTitle: 'Actief incident in uw omgeving', official: 'OFFICIEEL', communityLbl: 'Gemeenschap',
    call112: 'Noodgeval? Bel 112', resolvedBanner: 'Dit incident is opgelost.',
    followIncident: 'Incident volgen', followingIncident: 'Volgend',
    status_active: 'Actief', status_monitoring: 'Monitoring', status_resolved: 'Opgelost', status_archived: 'Gearchiveerd',
    sev_normal: 'Normaal', sev_high: 'Hoog', sev_critical: 'Kritiek',
    it_wildfire: 'Natuurbrand', it_flood: 'Overstroming', it_severe_weather: 'Extreem weer', it_road_closure: 'Wegafsluiting',
    it_power_outage: 'Stroomstoring', it_missing_person: 'Vermist persoon', it_other: 'Andere noodsituatie',
    ut_evacuation_order: 'Evacuatiebevel', ut_road_closure: 'Wegafsluiting', ut_shelter: 'Opvanglocatie',
    ut_emergency_instructions: 'Noodinstructies', ut_safe_route: 'Veilige route', ut_official_update: 'Officiële update',
    rc_smoke_seen: 'Rook gezien', rc_fire_location: 'Brandlocatie', rc_road_blocked: 'Weg geblokkeerd',
    rc_power_outage: 'Stroomstoring', rc_flooding: 'Overstroming', rc_fallen_tree: 'Omgevallen boom',
    rc_help_needed: 'Hulp nodig', rc_help_offered: 'Hulp aangeboden', rc_animal_assistance: 'Dierenhulp',
    rc_general_update: 'Lokale update',
    ht_transport: 'Vervoer', ht_accommodation: 'Tijdelijke opvang', ht_animal_transport: 'Dierenvervoer',
    ht_water: 'Water', ht_food: 'Voedsel', ht_phone_charging: 'Telefoons opladen', ht_welfare_check: 'Welzijnscontrole', ht_other: 'Andere hulp',
  },
  ar: {
    tabAlerts: 'التحديثات الرسمية',     unreadNotifications: 'إشعارات غير مقروءة',
tabIncidents: 'حوادث', tabCommunity: 'المجتمع', tabHelp: 'مساعدة',
    activeIncidents: 'حوادث نشطة', noIncidents: 'لا توجد حوادث حالياً — خبر جيد.',
    createIncident: 'إنشاء غرفة حادث', viewIncident: 'عرض الحادث', officialUpdates: 'التحديثات الرسمية',
    requestHelp: 'طلب مساعدة', offerHelp: 'تقديم مساعدة', communityReports: 'تقارير المجتمع',
    newReport: 'تقرير جديد', confirmSeen: 'رأيت هذا أيضاً', reply: 'رد', replies: 'الردود',
    reportIncorrect: 'الإبلاغ عن خطأ', share: 'مشاركة', witnessed: 'شاهدته بنفسي',
    town: 'البلدة', category: 'الفئة', submit: 'إرسال', cancel: 'إلغاء',
    expiredUpdates: 'تحديثات منتهية', showExpired: 'عرض المنتهية', hideExpired: 'إخفاء المنتهية',
    expired: 'منتهي', resolved: 'تم الحل', markResolved: 'وضع علامة تم الحل',
    needHelp: 'أحتاج مساعدة', canHelp: 'أستطيع المساعدة', signInToPost: 'سجّل الدخول للنشر',
    emergencyBannerTitle: 'حادث نشط في منطقتك', official: 'رسمي', communityLbl: 'المجتمع',
    call112: 'طوارئ؟ اتصل بـ 112', resolvedBanner: 'تم حل هذا الحادث.',
    followIncident: 'متابعة الحادث', followingIncident: 'متابع',
    status_active: 'نشط', status_monitoring: 'مراقبة', status_resolved: 'تم الحل', status_archived: 'مؤرشف',
    sev_normal: 'عادي', sev_high: 'مرتفع', sev_critical: 'حرج',
    it_wildfire: 'حريق غابات', it_flood: 'فيضان', it_severe_weather: 'طقس قاسٍ', it_road_closure: 'إغلاق طريق',
    it_power_outage: 'انقطاع كهرباء', it_missing_person: 'شخص مفقود', it_other: 'طارئ آخر',
    ut_evacuation_order: 'أمر إخلاء', ut_road_closure: 'إغلاق طريق', ut_shelter: 'موقع مأوى',
    ut_emergency_instructions: 'تعليمات الطوارئ', ut_safe_route: 'طريق آمن', ut_official_update: 'تحديث رسمي',
    rc_smoke_seen: 'دخان مرئي', rc_fire_location: 'موقع الحريق', rc_road_blocked: 'طريق مسدود',
    rc_power_outage: 'انقطاع الكهرباء', rc_flooding: 'فيضان', rc_fallen_tree: 'شجرة ساقطة',
    rc_help_needed: 'مساعدة مطلوبة', rc_help_offered: 'مساعدة معروضة', rc_animal_assistance: 'مساعدة الحيوانات',
    rc_general_update: 'تحديث محلي',
    ht_transport: 'نقل', ht_accommodation: 'سكن مؤقت', ht_animal_transport: 'نقل الحيوانات',
    ht_water: 'ماء', ht_food: 'طعام', ht_phone_charging: 'شحن الهواتف', ht_welfare_check: 'اطمئنان', ht_other: 'مساعدة أخرى',
  },
};

// Unified 7-category set for the Share Important Information composer + feed.
export const HUB_CATEGORIES = [
  { key: 'fire_smoke', emoji: '🔥', labelKey: 'catFireSmoke' },
  { key: 'safety_hazard', emoji: '⚠️', labelKey: 'catHazard' },
  { key: 'road_closure', emoji: '🚧', labelKey: 'catRoad' },
  { key: 'help_needed', emoji: '🤝', labelKey: 'catNeedHelp' },
  { key: 'help_offered', emoji: '❤️', labelKey: 'catOfferHelp' },
  { key: 'lost_pet', emoji: '🐶', labelKey: 'catPet' },
  { key: 'community_info', emoji: '📢', labelKey: 'catInfo' },
];
export const HUB_CATEGORY_EMOJI = Object.fromEntries(HUB_CATEGORIES.map(c => [c.key, c.emoji]));
export const HUB_CATEGORY_LABEL_KEY = Object.fromEntries(HUB_CATEGORIES.map(c => [c.key, c.labelKey]));

// Subtle Tailwind classes for the left category strip.
// Kept muted so the feed stays clean — the strip is the only splash of colour.
export const HUB_CATEGORY_STRIP = {
  fire_smoke: 'bg-red-500',
  safety_hazard: 'bg-orange-500',
  road_closure: 'bg-amber-500',
  help_needed: 'bg-blue-500',
  help_offered: 'bg-emerald-500',
  lost_pet: 'bg-purple-500',
  community_info: 'bg-gray-400',
};

export function useHubT() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').slice(0, 2);
  const dict = D[lang] || D.en;
  return (key, vars) => {
    const raw = dict[key] ?? D.en[key] ?? key;
    if (!vars || typeof raw !== 'string') return raw;
    // Simple `{name}` interpolation — enough for the count-remaining hint.
    return raw.replace(/\{(\w+)\}/g, (_m, k) => (vars[k] != null ? String(vars[k]) : ''));
  };
}

export default useHubT;
